import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  stars: 5,
  text: 'Excelente atención. Vinieron rápido y resolvieron el problema en el día.',
  name: 'Martín R.',
  location: 'Rosario'
}, {
  stars: 4,
  text: 'Teníamos hormigas en toda la cocina y quedó solucionado. Muy buena atención.',
  name: 'Carla M.',
  location: 'Funes'
}, {
  stars: 5,
  text: 'Servicio profesional y puntual. Muy recomendable.',
  name: 'Diego T.',
  location: 'Granadero Baigorria'
}, {
  stars: 4,
  text: 'Nos explicaron todo el proceso y dejaron garantía.',
  name: 'Paula G.',
  location: 'Pérez'
}, {
  stars: 5,
  text: 'Vinieron por una urgencia en nuestro local y respondieron enseguida.',
  name: 'Javier L.',
  location: 'Rosario'
}, {
  stars: 4,
  text: 'Muy amables y efectivos. Se nota la experiencia.',
  name: 'Luciana F.',
  location: 'Roldán'
}, {
  stars: 5,
  text: 'Excelente para empresas. Trabajo serio y prolijo.',
  name: 'Federico S.',
  location: 'Alvear'
}, {
  stars: 4,
  text: 'Había alacranes en el patio y actuaron muy rápido.',
  name: 'Natalia V.',
  location: 'Villa Gobernador Gálvez'
}, {
  stars: 5,
  text: 'Muy buena predisposición y resultados rápidos.',
  name: 'Gonzalo P.',
  location: 'Funes'
}, {
  stars: 4,
  text: 'Los contactamos por WhatsApp y vinieron el mismo día.',
  name: 'Romina C.',
  location: 'Rosario'
}, {
  stars: 4,
  text: 'Nos explicaron que el tratamiento no hace efecto total el primer día, pero a la semana ya notamos el cambio. Muy conformes.',
  name: 'Sergio M.',
  location: 'Rosario'
}, {
  stars: 5,
  text: 'Contratamos mantenimiento mensual para el local y desde entonces no volvimos a tener problemas.',
  name: 'Andrea P.',
  location: 'Funes'
}, {
  stars: 4,
  text: 'Al principio pensé que con una sola visita alcanzaba, pero me explicaron cómo funciona según la plaga. Muy transparentes.',
  name: 'Nicolás R.',
  location: 'Pérez'
}, {
  stars: 5,
  text: 'Después de la primera fumigación siguieron apareciendo algunas, pero nos habían avisado que era parte del proceso. Después desaparecieron.',
  name: 'Valeria T.',
  location: 'Rosario'
}];
export function Testimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    if (isHovered) return;
    const interval = setInterval(() => {
      if (scrollRef.current) {
        const {
          scrollLeft,
          scrollWidth,
          clientWidth
        } = scrollRef.current;
        const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 10;
        if (isAtEnd) {
          scrollRef.current.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        } else {
          // Scroll by roughly one card width (assuming ~300-400px per card)
          // We'll calculate the exact width of the first child
          const firstChild = scrollRef.current.firstElementChild as HTMLElement;
          const scrollAmount = firstChild ? firstChild.offsetWidth + 24 : 350; // 24 is the gap
          scrollRef.current.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
        }
      }
    }, 4000);
    return () => clearInterval(interval);
  }, [isHovered]);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const firstChild = scrollRef.current.firstElementChild as HTMLElement;
      const scrollAmount = firstChild ? firstChild.offsetWidth + 24 : 350;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-mobal-black py-20 overflow-hidden border-y border-gray-900" data-id="element-264">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-266">
          <h2 className="text-3xl md:text-5xl font-heading font-black text-mobal-white mb-4 uppercase" data-id="element-267">
            LO QUE DICEN NUESTROS CLIENTES
          </h2>
          <div className="w-24 h-1 bg-mobal-green mx-auto mb-6" data-id="element-268"></div>
          <p className="text-gray-400 font-body text-lg max-w-2xl mx-auto" data-id="element-269">
            La confianza de quienes ya nos eligieron es nuestra mejor garantía.
          </p>
        </motion.div>

        <div className="relative max-w-7xl mx-auto" data-id="element-270">
          {/* Navigation Arrows */}
          <button onClick={() => scroll('left')} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-12 z-10 bg-[#0a0a0a] border border-gray-800 text-mobal-white p-3 rounded-full hover:border-mobal-green hover:text-mobal-green transition-all shadow-xl hidden sm:flex items-center justify-center" aria-label="Anterior" data-id="element-271">
            <ChevronLeft className="w-6 h-6" data-id="element-272" />
          </button>

          <button onClick={() => scroll('right')} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-12 z-10 bg-[#0a0a0a] border border-gray-800 text-mobal-white p-3 rounded-full hover:border-mobal-green hover:text-mobal-green transition-all shadow-xl hidden sm:flex items-center justify-center" aria-label="Siguiente" data-id="element-273">
            <ChevronRight className="w-6 h-6" data-id="element-274" />
          </button>

          {/* Carousel Container */}
          <div ref={scrollRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory hide-scrollbar pb-8 pt-4 px-4 -mx-4 sm:px-0 sm:mx-0" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onTouchStart={() => setIsHovered(true)} onTouchEnd={() => setIsHovered(false)} style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-275">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.4,
            delay: Math.min(index * 0.1, 0.5)
          }} className="snap-center shrink-0 w-[85vw] sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] bg-[#0a0a0a] border border-gray-800 rounded-2xl p-8 flex flex-col justify-between hover:border-mobal-green/50 transition-colors shadow-lg" data-id="element-276">
                <div data-id="element-277">
                  <div className="flex items-center gap-1 mb-6" data-id="element-278">
                    {[...Array(5)].map((_, i) => <Star key={i} className={`w-5 h-5 ${i < testimonial.stars ? 'text-yellow-400 fill-yellow-400' : 'text-gray-700'}`} data-id="element-279" />)}
                  </div>
                  <p className="text-mobal-white font-body text-lg leading-relaxed mb-8 italic" data-id="element-280">
                    "{testimonial.text}"
                  </p>
                </div>

                <div className="border-t border-gray-800 pt-4 mt-auto" data-id="element-281">
                  <p className="font-heading font-bold text-mobal-white text-lg" data-id="element-282">
                    {testimonial.name}
                  </p>
                  <p className="text-mobal-green font-body text-sm" data-id="element-283">
                    {testimonial.location}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}